import React from 'react';
import { withRouteData } from 'react-static';
import './style.scss';

const Header = ({ small = false, children }) => (
  <header className={`header ${small ? 'header__small' : ''}`}>
    <div className="grid header--content">
      <a className="header--logo" href={process.env.GRC_URL} />
      <div className="header--menu">{children}</div>
    </div>
  </header>
);

export default withRouteData(Header);



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Header/index.js